import {cn} from '@containers/html-utils'
import * as React from 'react'

export const ProgressBar = (props: {
  value: number
  maxValue: number
  taskBg?: boolean
  className?: string
}) => {
  const valueText = `${props.value}/${props.maxValue}`
  return (
    <div className={cn('flex flex-1 items-center', props.className)}>
      <div
        className={cn(
          'chat-checklist-progress flex-1',
          !!props.taskBg && 'bg-progress-bar-old'
        )}
      >
        <div
          className={cn(
            'chat-checklist-progress-bar',
            props.maxValue === props.value && 'completed'
          )}
          style={{
            width: Math.round((100 * props.value) / props.maxValue) + '%'
          }}
        />
      </div>
      <div className="ml-8 text-11 relative">{valueText}</div>
    </div>
  )
}
